import styled from 'styled-components'
import { CLIENT_STYLINGS, size } from '../../../../utils/constants'
import { getBorderRadius, getShadow } from '../../../../utils/styleUtils'

export const GridWrapper = styled.div`
  background-color: transparent;
  width: 100%;
`

export const ItemImageWrapper = styled.div`
  margin-bottom: 10px;
  flex: 0 0 25%;

  @media (max-width: ${size.tablet}) {
    flex: 0 0 100%;
    margin-left: 0;
  }
`

export const ItemsWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;

  @media (max-width: ${size.laptop}) {
    justify-content: space-around;
  }
`

export const GridItemWrapper = styled.div`
  width: 100%;
  margin-bottom: 15px;
  margin: 10px;

  @media (max-width: ${size.tablet}) {
    width: 100%;
    margin-left: 0;
  }
`

export const GridItemDetailsWrapper = styled.div`
  display: flex;
  border-bottom: 1px solid
    ${props => CLIENT_STYLINGS[props.theme.organizationSlug].COLOR.BORDER};
  height: 100%;
  padding-top: 15px;
  box-shadow: ${props => getShadow(props, 'none')};

  @media (max-width: ${size.tablet}) {
    flex-direction: column;
    height: unset;
  }
`

export const ItemImage = styled.a`
  cursor: pointer;
  position: relative;
  height: 130px;
  background-image: url(${({ backgroundImage }) =>
      `"${encodeURI(backgroundImage)}"`}),
    url(${({ backgroundImage }) => `"${backgroundImage}"`});
  background-size: cover;
  background-position: center;
  padding: 10px;
  display: flex;
  flex-direction: column;
  justify-content: end;
`

export const TripDetailsWrapper = styled.div`
  margin-right: 5px;
  padding: 10px 15px;
  display: flex;
  flex-direction: column;
  min-height: 100px;
  justify-content: flex-start;
  position: relative;
  flex: 0 0 50%;

  @media (max-width: ${size.tablet}) {
    flex: 100%;
    margin: 0px;
    margin-right: 0px;
    padding: 15px 0 0 0;
  }
`

export const CardIconsWrapper = styled.div`
  display: flex;
  width: fit-content;
  padding: 0px;
  border-radius: ${props => getBorderRadius(props, 'sm')};
  background-color: transparent;
  text-align: left;
  padding-bottom: 20px;
`
export const CardIcon = styled.div`
  display: flex;
  align-items: flex-start;
  margin-right: 15px;
  color: ${props =>
    CLIENT_STYLINGS[props.theme.organizationSlug].COLOR.FOREGROUND};
`

export const CardIconText = styled.span`
  vertical-align: top;
  font-family: ${props =>
    CLIENT_STYLINGS[props.theme.organizationSlug].FONTS.SECONDARY};
  font-size: 14px;
  color: ${props =>
    CLIENT_STYLINGS[props.theme.organizationSlug].COLOR.FOREGROUND};
  line-height: 1.2;
  font-weight: 500;
`

export const TripInfoWrapper = styled.div`
  margin-right: 5px;
  padding: 10px 15px;
  display: flex;
  flex-direction: column;
  min-height: 100px;
  justify-content: flex-start;
  position: relative;
  flex: 0 0 25%;

  @media (max-width: ${size.tablet}) {
    flex: 100%;
    margin: 0px;
    padding: 0px;
    align-items: flex-start;
  }
`
export const TripInfo = styled.span`
  font-family: ${props =>
    CLIENT_STYLINGS[props.theme.organizationSlug].FONTS.SECONDARY};
  font-size: 16px;
  line-height: 20px;
  font-weight: 500;
  color: ${props =>
    CLIENT_STYLINGS[props.theme.organizationSlug].COLOR.SECONDARY_FOREGROUND};
  padding: 0;
  margin: 0;
  text-align: right;
  @media (max-width: ${size.tablet}) {
    text-align: left;
  }
`

export const Title = styled.a`
  font-family: ${props =>
    CLIENT_STYLINGS[props.theme.organizationSlug].FONTS.SECONDARY};
  font-size: 20px;
  line-height: 24px;
  font-weight: bold;
  color: ${props =>
    CLIENT_STYLINGS[props.theme.organizationSlug].COLOR.FOREGROUND};
  padding: 0;
  margin: 0;
  padding-bottom: 20px;
  text-align: left;
  text-transform: ${props =>
    CLIENT_STYLINGS[props.theme.organizationSlug]
      .GRID_ITEMS_TITLE_TEXT_TRANSFORM};
  cursor: pointer;

  @media (max-width: ${size.tablet}) {
    font-size: 18px;
    line-height: 22px;
  }
`

export const DescriptionWrapper = styled.div`
  display: flex;
  padding-bottom: 20px;
`

export const Description = styled.span`
  font-family: ${props =>
    CLIENT_STYLINGS[props.theme.organizationSlug].FONTS.SECONDARY};
  font-size: 16px;
  line-height: 20px;
  font-weight: 500;
  color: ${props =>
    CLIENT_STYLINGS[props.theme.organizationSlug].COLOR.SECONDARY_FOREGROUND};
  padding: 0;
  margin: 0;
  text-align: left;
`

export const TripPriceWrapper = styled.div`
  display: flex;
  flex-direction: column;
  padding: 15px 0px;

  @media (max-width: ${size.tablet}) {
    padding: 10px 0px;
  }
`

export const TripPrice = styled.span`
  font-family: ${props =>
    CLIENT_STYLINGS[props.theme.organizationSlug].FONTS.SECONDARY};
  font-size: 20px;
  line-height: 24px;
  font-weight: 700;
  color: #29785f;
  padding: 0;
  margin: 0;
  text-align: right;
  @media (max-width: ${size.tablet}) {
    text-align: left;
  }
`

export const TripPricePerPerson = styled.span`
  font-family: ${props =>
    CLIENT_STYLINGS[props.theme.organizationSlug].FONTS.SECONDARY};
  font-size: 16px;
  line-height: 20px;
  font-weight: 500;
  color: ${props =>
    CLIENT_STYLINGS[props.theme.organizationSlug].COLOR.SECONDARY_FOREGROUND};
  padding: 0;
  margin: 0;
  text-align: right;
  @media (max-width: ${size.tablet}) {
    text-align: left;
  }
`

export const GridTitle = styled.h2`
  position: inherit;
  top: unset;
  right: unset;
  background-color: unset;
  font-family: ${props =>
    CLIENT_STYLINGS[props.theme.organizationSlug].FONTS.SECONDARY};
  color: ${props =>
    CLIENT_STYLINGS[props.theme.organizationSlug].COLOR.FOREGROUND};
  font-size: 20px;
  line-height: 30px;
  font-weight: 800;
  margin: 20px 0 15px;
  text-transform: uppercase;
  text-align: ${props => {
    return props?.isChatMode ? 'center' : 'left'
  }};

  @media (max-width: ${size.tablet}) {
    font-size: 16px;
    line-height: 20px;
    margin: 20px 0 15px;
  }
`

export const GridSubtitle = styled.h2`
  position: inherit;
  top: unset;
  right: unset;
  background-color: unset;
  font-family: ${props =>
    CLIENT_STYLINGS[props.theme.organizationSlug].FONTS.SECONDARY};
  color: ${props =>
    CLIENT_STYLINGS[props.theme.organizationSlug].COLOR.MUTED_FOREGROUND};
  font-size: 16px;
  line-height: 20px;
  font-weight: 500;
  margin: 15px 0px 25px 0px !important;
  padding: ${props => {
    return props?.isChatMode ? '0px 15px 0px 15px' : '0px'
  }};
  text-align: ${props => {
    return props?.isChatMode ? 'center' : 'left'
  }};
  text-align: center;
  font-style: italic;

  @media (max-width: ${size.tablet}) {
    font-size: 14px;
    line-height: 20px;
    margin: 15px 0px 25px 0px !important;
  }
`

export const MoreInfoWrapper = styled.div`
  display: flex;
  justify-content: flex-start;
`

export const MoreInfoLink = styled.a`
  font-family: ${props =>
    CLIENT_STYLINGS[props.theme.organizationSlug].FONTS.SECONDARY};
  font-size: 14px;
  line-height: 16px;
  font-weight: bold;
  color: ${props =>
    CLIENT_STYLINGS[props.theme.organizationSlug].COLOR.PRIMARY};
  padding: 0;
  margin: 0;
  padding-bottom: 20px;
  text-align: left;
  cursor: pointer;
  text-decoration: underline;
`

export const ShowMoreCta = styled.button`
  display: flex;
  outline: none;
  border-style: solid;
  border-width: 1px;
  border-color: ${props =>
    CLIENT_STYLINGS[props.theme.organizationSlug].COLOR.PRIMARY};
  border-radius: ${props => getBorderRadius(props, 'sm')};
  background-color: ${props =>
    CLIENT_STYLINGS[props.theme.organizationSlug].COLOR.PRIMARY};
  width: fit-content;
  color: ${props =>
    CLIENT_STYLINGS[props.theme.organizationSlug].COLOR.PRIMARY_FOREGROUND};
  cursor: pointer;
  padding: 7px 10px;
  text-align: center;
  font-size: 16px;
  font-weight: 700;
  font-family: ${props =>
    CLIENT_STYLINGS[props.theme.organizationSlug].FONTS.PRIMARY};
  text-decoration: none;
  align-self: center;
  bottom: 0px;
  margin: 15px auto;
  align-self: stretch;

  @media (max-width: ${size.laptop}) {
    font-size: 14px;
  }

  -webkit-transition: 0.25s ease;
  -moz-transition: 0.25s ease;
  -o-transition: 0.25s ease;
  transition: 0.25s ease;

  &:hover {
    transform: scale(1.025);
    background: ${props =>
      CLIENT_STYLINGS[props.theme.organizationSlug].COLOR.BACKGROUND};
    color: ${props =>
      CLIENT_STYLINGS[props.theme.organizationSlug].COLOR.PRIMARY};
    border-color: ${props =>
      CLIENT_STYLINGS[props.theme.organizationSlug].COLOR.BORDER};
  }

  &:after {
    content: none;
  }
  &:before {
    content: none;
  }
`
